import React from 'react';
import Modal from '../../Modal';

export default function PreviewModal({url, onClose}) {
    return <Modal isOpen={Boolean(url)} title="Storefront draft preview" onClose={onClose} size="large">
        <div className="content-preview-toolbar" role="group" aria-label="Preview size">
            <p>This uses the real storefront renderer. Draft previews are private and expire shortly.</p>
        </div>
        {url && <iframe
            className="content-preview-frame"
            title="Storefront draft preview"
            src={url}
            sandbox="allow-scripts allow-forms allow-popups"
        />}
    </Modal>;
}
